import React from 'react';
import { Box, Typography } from '@material-ui/core';

const UserList: React.FC = () => {
  return (
    <Box p={3}>
      <Typography variant="h4">User List</Typography>
      <Typography variant="body1">User List component - To be implemented</Typography>
    </Box>
  );
};

export default UserList; 